import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/**
 * The HyperTek prototype's textarea (h-prototype `components/ui/textarea.tsx`), class for class, plus the
 * invalid pair Input documents: red when invalid, and still red while it has focus.
 */
function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-[56px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
